import { render } from 'preact'
// import './assets/index.css'
import { App } from './app.jsx'
import './index.css';

render(<App />, document.getElementById('ruler'))
